import styled from "styled-components/macro";

export const Section = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 5px 0 5px 19px;
  white-space: nowrap;
`;
